import { buildImageUrl, Transformations } from 'utils/cloud-image';

export const getDrp2ImageSize = (width: number, height: number) => ({
  width: width * 2,
  height: height * 2,
});

export const getImageSrc = (imagePath: string, transformations: Transformations, drp2 = false) => {
  const transform = drp2
    ? {
        ...transformations,
        ...getDrp2ImageSize(transformations.width, transformations.height),
      }
    : transformations;

  return buildImageUrl(imagePath, transform);
};
